import { render, staticRenderFns } from "./ProductActionDeleteVariant.vue?vue&type=template&id=2b029efa&"
import script from "./ProductActionDeleteVariant.vue?vue&type=script&lang=ts&"
export * from "./ProductActionDeleteVariant.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports